export class NativeStreamListOutputField {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "NativeStreamListOutputKind",
            "format": ""
        },
        {
            "name": "items",
            "baseName": "items",
            "type": "NativeStreamOutputType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamListOutputField.attributeTypeMap;
    }
    constructor() {
    }
}
